import { combineReducers } from "redux";
import catalogManagementUnits from "./catalogManagementUnitsReducer";
import catalogFinancialReducer from "./catalogFinancialReducer";
import catalogWorkPlans from "./catalogWorkPlanReducer";
import apiCallsInProgress from "./apiStatusReducer";

const rootReducer = combineReducers({
  catalogManagementUnits,
  catalogFinancialReducer,
  catalogWorkPlans,
  apiCallsInProgress,
});

export default rootReducer;
